import { render, staticRenderFns } from "./ScreensaversInterval.vue?vue&type=template&id=310a92d0&scoped=true"
import script from "./ScreensaversInterval.vue?vue&type=script&lang=js"
export * from "./ScreensaversInterval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310a92d0",
  null
  
)

export default component.exports